import { createStore } from 'owa-satcheljs';
import type CommandBarState from './schema/CommandBarState';
import NavigationButton from './schema/NavigationButton';

const defaultExport: () => CommandBarState = createStore<CommandBarState>('commandBarStore', {
    navigationButtonSelected: NavigationButton.Email,
    hidden: false,
});
export default defaultExport;
